import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Sidebar from '../../components/ui/Sidebar';
import Icon from '../../components/AppIcon';
import ProfileTab from './components/ProfileTab';
import CompanyTab from './components/CompanyTab';
import TeamTab from './components/TeamTab';

const AccountSettings = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('profile');
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const tabs = [
    { id: 'profile', label: t('accountSettings.tabs.profile'), icon: 'User' },
    { id: 'company', label: t('accountSettings.tabs.company'), icon: 'Building2' },
    { id: 'team', label: t('accountSettings.tabs.team'), icon: 'Users' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return <ProfileTab />;
      case 'company':
        return <CompanyTab />;
      case 'team':
        return <TeamTab />;
      default:
        return <ProfileTab />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Sidebar isCollapsed={isSidebarCollapsed} onToggle={setIsSidebarCollapsed} />
      <div
        className={`transition-all duration-250 ${
          isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-[280px]'
        }`}
      >
        <div className="p-4 md:p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6 md:mb-8">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
                {t('accountSettings.title')}
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                {t('accountSettings.subtitle')}
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-6 md:gap-8">
              <div className="lg:w-64 flex-shrink-0">
                <div className="bg-card border border-border rounded-lg overflow-hidden">
                  <div className="overflow-x-auto lg:overflow-x-visible">
                    <div className="flex lg:flex-col min-w-max lg:min-w-0">
                      {tabs?.map((tab) => (
                        <button
                          key={tab?.id}
                          onClick={() => setActiveTab(tab?.id)}
                          className={`flex items-center gap-3 px-4 md:px-6 py-3 md:py-4 text-sm md:text-base font-medium transition-colors whitespace-nowrap ${
                            activeTab === tab?.id
                              ? 'bg-accent/10 text-accent border-r-2 lg:border-r-2 lg:border-b-0 border-accent' :'text-muted-foreground hover:bg-muted hover:text-foreground'
                          }`}
                        >
                          <Icon name={tab?.icon} size={20} className="flex-shrink-0" />
                          <span>{tab?.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1 min-w-0">
                {renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;